"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Accessorial = _interopRequireDefault(require("./Accessorial"));

var _AuctionStats = _interopRequireDefault(require("./AuctionStats"));

var _BaseShipment = _interopRequireDefault(require("./BaseShipment"));

var _CurrentShipmentAddress = _interopRequireDefault(require("./CurrentShipmentAddress"));

var _EquipmentConfig = _interopRequireDefault(require("./EquipmentConfig"));

var _EquipmentType = _interopRequireDefault(require("./EquipmentType"));

var _ServiceLevel = _interopRequireDefault(require("./ServiceLevel"));

var _ShipmentCustomData = _interopRequireDefault(require("./ShipmentCustomData"));

var _ShipmentLineItem = _interopRequireDefault(require("./ShipmentLineItem"));

var _ShipmentMetadata = _interopRequireDefault(require("./ShipmentMetadata"));

var _ShipmentMode = _interopRequireDefault(require("./ShipmentMode"));

var _ShipmentRep = _interopRequireDefault(require("./ShipmentRep"));

var _ShipmentTimelineEvent = _interopRequireDefault(require("./ShipmentTimelineEvent"));

var _SlimCarrierAssignment = _interopRequireDefault(require("./SlimCarrierAssignment"));

var _SlimCarrierStatusCarrierAssignment = _interopRequireDefault(require("./SlimCarrierStatusCarrierAssignment"));

var _SlimCompany = _interopRequireDefault(require("./SlimCompany"));

var _SlimRFQ = _interopRequireDefault(require("./SlimRFQ"));

var _SlimShipmentAllOf = _interopRequireDefault(require("./SlimShipmentAllOf"));

var _SlimUser = _interopRequireDefault(require("./SlimUser"));

var _Stop = _interopRequireDefault(require("./Stop"));

var _TotalWeightOverride = _interopRequireDefault(require("./TotalWeightOverride"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The SlimShipment model module.
 * @module model/SlimShipment
 * @version 2.7.64
 */
var SlimShipment = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SlimShipment</code>.
   * @alias module:model/SlimShipment
   * @implements module:model/BaseShipment
   * @implements module:model/SlimShipmentAllOf
   * @param id {String} 
   */
  function SlimShipment(id) {
    _classCallCheck(this, SlimShipment);

    _BaseShipment["default"].initialize(this, id);

    _SlimShipmentAllOf["default"].initialize(this);

    SlimShipment.initialize(this, id);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(SlimShipment, null, [{
    key: "initialize",
    value: function initialize(obj, id) {
      obj['id'] = id;
    }
    /**
     * Constructs a <code>SlimShipment</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SlimShipment} obj Optional instance to populate.
     * @return {module:model/SlimShipment} The populated <code>SlimShipment</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SlimShipment();

        _BaseShipment["default"].constructFromObject(data, obj);

        _SlimShipmentAllOf["default"].constructFromObject(data, obj);

        if (data.hasOwnProperty('accessorials')) {
          obj['accessorials'] = _ApiClient["default"].convertToType(data['accessorials'], [_Accessorial["default"]]);
        }

        if (data.hasOwnProperty('additional_bol_recipients')) {
          obj['additional_bol_recipients'] = _ApiClient["default"].convertToType(data['additional_bol_recipients'], ['String']);
        }

        if (data.hasOwnProperty('auction_stats')) {
          obj['auction_stats'] = _AuctionStats["default"].constructFromObject(data['auction_stats']);
        }

        if (data.hasOwnProperty('bol_number')) {
          obj['bol_number'] = _ApiClient["default"].convertToType(data['bol_number'], 'String');
        }

        if (data.hasOwnProperty('cancellation_reason')) {
          obj['cancellation_reason'] = _ApiClient["default"].convertToType(data['cancellation_reason'], 'String');
        }

        if (data.hasOwnProperty('capacity_provider_customer_reference_number')) {
          obj['capacity_provider_customer_reference_number'] = _ApiClient["default"].convertToType(data['capacity_provider_customer_reference_number'], 'String');
        }

        if (data.hasOwnProperty('created_at')) {
          obj['created_at'] = _ApiClient["default"].convertToType(data['created_at'], 'Date');
        }

        if (data.hasOwnProperty('created_by_source')) {
          obj['created_by_source'] = _ApiClient["default"].convertToType(data['created_by_source'], 'String');
        }

        if (data.hasOwnProperty('created_by_user')) {
          obj['created_by_user'] = _SlimUser["default"].constructFromObject(data['created_by_user']);
        }

        if (data.hasOwnProperty('current_address')) {
          obj['current_address'] = _CurrentShipmentAddress["default"].constructFromObject(data['current_address']);
        }

        if (data.hasOwnProperty('custom_data')) {
          obj['custom_data'] = _ShipmentCustomData["default"].constructFromObject(data['custom_data']);
        }

        if (data.hasOwnProperty('customer')) {
          obj['customer'] = _SlimCompany["default"].constructFromObject(data['customer']);
        }

        if (data.hasOwnProperty('customer_reference_number')) {
          obj['customer_reference_number'] = _ApiClient["default"].convertToType(data['customer_reference_number'], 'String');
        }

        if (data.hasOwnProperty('delayed')) {
          obj['delayed'] = _ApiClient["default"].convertToType(data['delayed'], 'Boolean');
        }

        if (data.hasOwnProperty('description')) {
          obj['description'] = _ApiClient["default"].convertToType(data['description'], 'String');
        }

        if (data.hasOwnProperty('documents_count')) {
          obj['documents_count'] = _ApiClient["default"].convertToType(data['documents_count'], 'Number');
        }

        if (data.hasOwnProperty('drayage_booking_number')) {
          obj['drayage_booking_number'] = _ApiClient["default"].convertToType(data['drayage_booking_number'], 'String');
        }

        if (data.hasOwnProperty('drayage_chassis_number')) {
          obj['drayage_chassis_number'] = _ApiClient["default"].convertToType(data['drayage_chassis_number'], 'String');
        }

        if (data.hasOwnProperty('drayage_container_number')) {
          obj['drayage_container_number'] = _ApiClient["default"].convertToType(data['drayage_container_number'], 'String');
        }

        if (data.hasOwnProperty('drayage_container_return_date')) {
          obj['drayage_container_return_date'] = _ApiClient["default"].convertToType(data['drayage_container_return_date'], 'String');
        }

        if (data.hasOwnProperty('drayage_estimated_arrival_date')) {
          obj['drayage_estimated_arrival_date'] = _ApiClient["default"].convertToType(data['drayage_estimated_arrival_date'], 'String');
        }

        if (data.hasOwnProperty('drayage_last_free_date')) {
          obj['drayage_last_free_date'] = _ApiClient["default"].convertToType(data['drayage_last_free_date'], 'String');
        }

        if (data.hasOwnProperty('drayage_release_date')) {
          obj['drayage_release_date'] = _ApiClient["default"].convertToType(data['drayage_release_date'], 'String');
        }

        if (data.hasOwnProperty('drayage_seal_number')) {
          obj['drayage_seal_number'] = _ApiClient["default"].convertToType(data['drayage_seal_number'], 'String');
        }

        if (data.hasOwnProperty('equipment_config')) {
          obj['equipment_config'] = _EquipmentConfig["default"].constructFromObject(data['equipment_config']);
        }

        if (data.hasOwnProperty('equipment_type')) {
          obj['equipment_type'] = _EquipmentType["default"].constructFromObject(data['equipment_type']);
        }

        if (data.hasOwnProperty('est_trip_miles')) {
          obj['est_trip_miles'] = _ApiClient["default"].convertToType(data['est_trip_miles'], 'Number');
        }

        if (data.hasOwnProperty('external_tracking_link')) {
          obj['external_tracking_link'] = _ApiClient["default"].convertToType(data['external_tracking_link'], 'String');
        }

        if (data.hasOwnProperty('final_trip_miles')) {
          obj['final_trip_miles'] = _ApiClient["default"].convertToType(data['final_trip_miles'], 'Number');
        }

        if (data.hasOwnProperty('group_id')) {
          obj['group_id'] = _ApiClient["default"].convertToType(data['group_id'], 'String');
        }

        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'String');
        }

        if (data.hasOwnProperty('is_watchable')) {
          obj['is_watchable'] = _ApiClient["default"].convertToType(data['is_watchable'], 'Boolean');
        }

        if (data.hasOwnProperty('is_watched')) {
          obj['is_watched'] = _ApiClient["default"].convertToType(data['is_watched'], 'Boolean');
        }

        if (data.hasOwnProperty('last_cloned_at')) {
          obj['last_cloned_at'] = _ApiClient["default"].convertToType(data['last_cloned_at'], 'Date');
        }

        if (data.hasOwnProperty('line_items')) {
          obj['line_items'] = _ApiClient["default"].convertToType(data['line_items'], [_ShipmentLineItem["default"]]);
        }

        if (data.hasOwnProperty('marked_as_paid_by_user')) {
          obj['marked_as_paid_by_user'] = _ApiClient["default"].convertToType(data['marked_as_paid_by_user'], 'String');
        }

        if (data.hasOwnProperty('markup')) {
          obj['markup'] = _ApiClient["default"].convertToType(data['markup'], 'Number');
        }

        if (data.hasOwnProperty('messages_count')) {
          obj['messages_count'] = _ApiClient["default"].convertToType(data['messages_count'], 'Number');
        }

        if (data.hasOwnProperty('metadata')) {
          obj['metadata'] = _ShipmentMetadata["default"].constructFromObject(data['metadata']);
        }

        if (data.hasOwnProperty('mode')) {
          obj['mode'] = _ShipmentMode["default"].constructFromObject(data['mode']);
        }

        if (data.hasOwnProperty('name')) {
          obj['name'] = _ApiClient["default"].convertToType(data['name'], 'String');
        }

        if (data.hasOwnProperty('next_planned_stop_id')) {
          obj['next_planned_stop_id'] = _ApiClient["default"].convertToType(data['next_planned_stop_id'], 'String');
        }

        if (data.hasOwnProperty('notes_count')) {
          obj['notes_count'] = _ApiClient["default"].convertToType(data['notes_count'], 'Number');
        }

        if (data.hasOwnProperty('notes_for_carrier')) {
          obj['notes_for_carrier'] = _ApiClient["default"].convertToType(data['notes_for_carrier'], 'String');
        }

        if (data.hasOwnProperty('parcel_pickup_status')) {
          obj['parcel_pickup_status'] = _ApiClient["default"].convertToType(data['parcel_pickup_status'], 'String');
        }

        if (data.hasOwnProperty('pickup_number')) {
          obj['pickup_number'] = _ApiClient["default"].convertToType(data['pickup_number'], 'String');
        }

        if (data.hasOwnProperty('preferred_currency')) {
          obj['preferred_currency'] = _ApiClient["default"].convertToType(data['preferred_currency'], 'String');
        }

        if (data.hasOwnProperty('pro_number')) {
          obj['pro_number'] = _ApiClient["default"].convertToType(data['pro_number'], 'String');
        }

        if (data.hasOwnProperty('purchase_order_number')) {
          obj['purchase_order_number'] = _ApiClient["default"].convertToType(data['purchase_order_number'], 'String');
        }

        if (data.hasOwnProperty('reference_id')) {
          obj['reference_id'] = _ApiClient["default"].convertToType(data['reference_id'], 'String');
        }

        if (data.hasOwnProperty('relationship_to_customer')) {
          obj['relationship_to_customer'] = _SlimCarrierAssignment["default"].constructFromObject(data['relationship_to_customer']);
        }

        if (data.hasOwnProperty('relationship_to_vendor')) {
          obj['relationship_to_vendor'] = _SlimCarrierStatusCarrierAssignment["default"].constructFromObject(data['relationship_to_vendor']);
        }

        if (data.hasOwnProperty('reps')) {
          obj['reps'] = _ApiClient["default"].convertToType(data['reps'], [_ShipmentRep["default"]]);
        }

        if (data.hasOwnProperty('rfqs')) {
          obj['rfqs'] = _ApiClient["default"].convertToType(data['rfqs'], [_SlimRFQ["default"]]);
        }

        if (data.hasOwnProperty('service_level')) {
          obj['service_level'] = _ServiceLevel["default"].constructFromObject(data['service_level']);
        }

        if (data.hasOwnProperty('shipment_pickup')) {
          obj['shipment_pickup'] = _ApiClient["default"].convertToType(data['shipment_pickup'], 'String');
        }

        if (data.hasOwnProperty('significantly_modified_at')) {
          obj['significantly_modified_at'] = _ApiClient["default"].convertToType(data['significantly_modified_at'], 'Date');
        }

        if (data.hasOwnProperty('state')) {
          obj['state'] = _ApiClient["default"].convertToType(data['state'], 'String');
        }

        if (data.hasOwnProperty('stops')) {
          obj['stops'] = _ApiClient["default"].convertToType(data['stops'], [_Stop["default"]]);
        }

        if (data.hasOwnProperty('temperature_lower_limit')) {
          obj['temperature_lower_limit'] = _ApiClient["default"].convertToType(data['temperature_lower_limit'], 'Number');
        }

        if (data.hasOwnProperty('temperature_upper_limit')) {
          obj['temperature_upper_limit'] = _ApiClient["default"].convertToType(data['temperature_upper_limit'], 'Number');
        }

        if (data.hasOwnProperty('timeline_events')) {
          obj['timeline_events'] = _ApiClient["default"].convertToType(data['timeline_events'], [_ShipmentTimelineEvent["default"]]);
        }

        if (data.hasOwnProperty('timeline_last_updated_at')) {
          obj['timeline_last_updated_at'] = _ApiClient["default"].convertToType(data['timeline_last_updated_at'], 'Date');
        }

        if (data.hasOwnProperty('total_declared_value')) {
          obj['total_declared_value'] = _ApiClient["default"].convertToType(data['total_declared_value'], 'Number');
        }

        if (data.hasOwnProperty('total_declared_value_currency')) {
          obj['total_declared_value_currency'] = _ApiClient["default"].convertToType(data['total_declared_value_currency'], 'String');
        }

        if (data.hasOwnProperty('total_linear_feet')) {
          obj['total_linear_feet'] = _ApiClient["default"].convertToType(data['total_linear_feet'], 'Number');
        }

        if (data.hasOwnProperty('total_miles')) {
          obj['total_miles'] = _ApiClient["default"].convertToType(data['total_miles'], 'Number');
        }

        if (data.hasOwnProperty('total_weight_override')) {
          obj['total_weight_override'] = _TotalWeightOverride["default"].constructFromObject(data['total_weight_override']);
        }

        if (data.hasOwnProperty('tracking_number')) {
          obj['tracking_number'] = _ApiClient["default"].convertToType(data['tracking_number'], 'String');
        }

        if (data.hasOwnProperty('trailer_name')) {
          obj['trailer_name'] = _ApiClient["default"].convertToType(data['trailer_name'], 'String');
        }

        if (data.hasOwnProperty('updated_at')) {
          obj['updated_at'] = _ApiClient["default"].convertToType(data['updated_at'], 'Date');
        }

        if (data.hasOwnProperty('v3_shipment_id')) {
          obj['v3_shipment_id'] = _ApiClient["default"].convertToType(data['v3_shipment_id'], 'String');
        }

        if (data.hasOwnProperty('version')) {
          obj['version'] = _ApiClient["default"].convertToType(data['version'], 'Number');
        }

        if (data.hasOwnProperty('current_carrier')) {
          obj['current_carrier'] = _SlimCompany["default"].constructFromObject(data['current_carrier']);
        }
      }

      return obj;
    }
  }]);

  return SlimShipment;
}();
/**
 * @member {Array.<module:model/Accessorial>} accessorials
 */


SlimShipment.prototype['accessorials'] = undefined;
/**
 * Additional email address to send the BOL to upon booking
 * @member {Array.<String>} additional_bol_recipients
 */

SlimShipment.prototype['additional_bol_recipients'] = undefined;
/**
 * @member {module:model/AuctionStats} auction_stats
 */

SlimShipment.prototype['auction_stats'] = undefined;
/**
 * @member {String} bol_number
 */

SlimShipment.prototype['bol_number'] = undefined;
/**
 * @member {String} cancellation_reason
 */

SlimShipment.prototype['cancellation_reason'] = undefined;
/**
 * Customer reference number that came back from the capacity provider
 * @member {String} capacity_provider_customer_reference_number
 */

SlimShipment.prototype['capacity_provider_customer_reference_number'] = undefined;
/**
 * @member {Date} created_at
 */

SlimShipment.prototype['created_at'] = undefined;
/**
 * @member {module:model/SlimShipment.CreatedBySourceEnum} created_by_source
 */

SlimShipment.prototype['created_by_source'] = undefined;
/**
 * @member {module:model/SlimUser} created_by_user
 */

SlimShipment.prototype['created_by_user'] = undefined;
/**
 * @member {module:model/CurrentShipmentAddress} current_address
 */

SlimShipment.prototype['current_address'] = undefined;
/**
 * @member {module:model/ShipmentCustomData} custom_data
 */

SlimShipment.prototype['custom_data'] = undefined;
/**
 * @member {module:model/SlimCompany} customer
 */

SlimShipment.prototype['customer'] = undefined;
/**
 * @member {String} customer_reference_number
 */

SlimShipment.prototype['customer_reference_number'] = undefined;
/**
 * @member {Boolean} delayed
 */

SlimShipment.prototype['delayed'] = undefined;
/**
 * @member {String} description
 */

SlimShipment.prototype['description'] = undefined;
/**
 * @member {Number} documents_count
 */

SlimShipment.prototype['documents_count'] = undefined;
/**
 * @member {String} drayage_booking_number
 */

SlimShipment.prototype['drayage_booking_number'] = undefined;
/**
 * @member {String} drayage_chassis_number
 */

SlimShipment.prototype['drayage_chassis_number'] = undefined;
/**
 * @member {String} drayage_container_number
 */

SlimShipment.prototype['drayage_container_number'] = undefined;
/**
 * @member {String} drayage_container_return_date
 */

SlimShipment.prototype['drayage_container_return_date'] = undefined;
/**
 * @member {String} drayage_estimated_arrival_date
 */

SlimShipment.prototype['drayage_estimated_arrival_date'] = undefined;
/**
 * @member {String} drayage_last_free_date
 */

SlimShipment.prototype['drayage_last_free_date'] = undefined;
/**
 * @member {String} drayage_release_date
 */

SlimShipment.prototype['drayage_release_date'] = undefined;
/**
 * @member {String} drayage_seal_number
 */

SlimShipment.prototype['drayage_seal_number'] = undefined;
/**
 * @member {module:model/EquipmentConfig} equipment_config
 */

SlimShipment.prototype['equipment_config'] = undefined;
/**
 * @member {module:model/EquipmentType} equipment_type
 */

SlimShipment.prototype['equipment_type'] = undefined;
/**
 * @member {Number} est_trip_miles
 */

SlimShipment.prototype['est_trip_miles'] = undefined;
/**
 * @member {String} external_tracking_link
 */

SlimShipment.prototype['external_tracking_link'] = undefined;
/**
 * @member {Number} final_trip_miles
 */

SlimShipment.prototype['final_trip_miles'] = undefined;
/**
 * @member {String} group_id
 */

SlimShipment.prototype['group_id'] = undefined;
/**
 * @member {String} id
 */

SlimShipment.prototype['id'] = undefined;
/**
 * @member {Boolean} is_watchable
 */

SlimShipment.prototype['is_watchable'] = undefined;
/**
 * @member {Boolean} is_watched
 */

SlimShipment.prototype['is_watched'] = undefined;
/**
 * @member {Date} last_cloned_at
 */

SlimShipment.prototype['last_cloned_at'] = undefined;
/**
 * @member {Array.<module:model/ShipmentLineItem>} line_items
 */

SlimShipment.prototype['line_items'] = undefined;
/**
 * @member {String} marked_as_paid_by_user
 */

SlimShipment.prototype['marked_as_paid_by_user'] = undefined;
/**
 * @member {Number} markup
 */

SlimShipment.prototype['markup'] = undefined;
/**
 * @member {Number} messages_count
 */

SlimShipment.prototype['messages_count'] = undefined;
/**
 * @member {module:model/ShipmentMetadata} metadata
 */

SlimShipment.prototype['metadata'] = undefined;
/**
 * @member {module:model/ShipmentMode} mode
 */

SlimShipment.prototype['mode'] = undefined;
/**
 * @member {String} name
 */

SlimShipment.prototype['name'] = undefined;
/**
 * @member {String} next_planned_stop_id
 */

SlimShipment.prototype['next_planned_stop_id'] = undefined;
/**
 * @member {Number} notes_count
 */

SlimShipment.prototype['notes_count'] = undefined;
/**
 * @member {String} notes_for_carrier
 */

SlimShipment.prototype['notes_for_carrier'] = undefined;
/**
 * @member {module:model/SlimShipment.ParcelPickupStatusEnum} parcel_pickup_status
 */

SlimShipment.prototype['parcel_pickup_status'] = undefined;
/**
 * @member {String} pickup_number
 */

SlimShipment.prototype['pickup_number'] = undefined;
/**
 * @member {String} preferred_currency
 */

SlimShipment.prototype['preferred_currency'] = undefined;
/**
 * @member {String} pro_number
 */

SlimShipment.prototype['pro_number'] = undefined;
/**
 * @member {String} purchase_order_number
 */

SlimShipment.prototype['purchase_order_number'] = undefined;
/**
 * @member {String} reference_id
 */

SlimShipment.prototype['reference_id'] = undefined;
/**
 * @member {module:model/SlimCarrierAssignment} relationship_to_customer
 */

SlimShipment.prototype['relationship_to_customer'] = undefined;
/**
 * @member {module:model/SlimCarrierStatusCarrierAssignment} relationship_to_vendor
 */

SlimShipment.prototype['relationship_to_vendor'] = undefined;
/**
 * Representatives for the Shipment from within the requesting user's own company 
 * @member {Array.<module:model/ShipmentRep>} reps
 */

SlimShipment.prototype['reps'] = undefined;
/**
 * All RFQs this Shipment has run, slimmed down to exclude their quotes 
 * @member {Array.<module:model/SlimRFQ>} rfqs
 */

SlimShipment.prototype['rfqs'] = undefined;
/**
 * @member {module:model/ServiceLevel} service_level
 */

SlimShipment.prototype['service_level'] = undefined;
/**
 * @member {String} shipment_pickup
 */

SlimShipment.prototype['shipment_pickup'] = undefined;
/**
 * Not implemented
 * @member {Date} significantly_modified_at
 */

SlimShipment.prototype['significantly_modified_at'] = undefined;
/**
 * @member {module:model/SlimShipment.StateEnum} state
 */

SlimShipment.prototype['state'] = undefined;
/**
 * @member {Array.<module:model/Stop>} stops
 */

SlimShipment.prototype['stops'] = undefined;
/**
 * @member {Number} temperature_lower_limit
 */

SlimShipment.prototype['temperature_lower_limit'] = undefined;
/**
 * @member {Number} temperature_upper_limit
 */

SlimShipment.prototype['temperature_upper_limit'] = undefined;
/**
 * @member {Array.<module:model/ShipmentTimelineEvent>} timeline_events
 */

SlimShipment.prototype['timeline_events'] = undefined;
/**
 * @member {Date} timeline_last_updated_at
 */

SlimShipment.prototype['timeline_last_updated_at'] = undefined;
/**
 * @member {Number} total_declared_value
 */

SlimShipment.prototype['total_declared_value'] = undefined;
/**
 * @member {module:model/SlimShipment.TotalDeclaredValueCurrencyEnum} total_declared_value_currency
 */

SlimShipment.prototype['total_declared_value_currency'] = undefined;
/**
 * @member {Number} total_linear_feet
 */

SlimShipment.prototype['total_linear_feet'] = undefined;
/**
 * @member {Number} total_miles
 */

SlimShipment.prototype['total_miles'] = undefined;
/**
 * @member {module:model/TotalWeightOverride} total_weight_override
 */

SlimShipment.prototype['total_weight_override'] = undefined;
/**
 * @member {String} tracking_number
 */

SlimShipment.prototype['tracking_number'] = undefined;
/**
 * @member {String} trailer_name
 */

SlimShipment.prototype['trailer_name'] = undefined;
/**
 * @member {Date} updated_at
 */

SlimShipment.prototype['updated_at'] = undefined;
/**
 * @member {String} v3_shipment_id
 */

SlimShipment.prototype['v3_shipment_id'] = undefined;
/**
 * @member {module:model/SlimShipment.VersionEnum} version
 */

SlimShipment.prototype['version'] = undefined;
/**
 * @member {module:model/SlimCompany} current_carrier
 */

SlimShipment.prototype['current_carrier'] = undefined; // Implement BaseShipment interface:

/**
 * @member {Array.<module:model/Accessorial>} accessorials
 */

_BaseShipment["default"].prototype['accessorials'] = undefined;
/**
 * Additional email address to send the BOL to upon booking
 * @member {Array.<String>} additional_bol_recipients
 */

_BaseShipment["default"].prototype['additional_bol_recipients'] = undefined;
/**
 * @member {module:model/AuctionStats} auction_stats
 */

_BaseShipment["default"].prototype['auction_stats'] = undefined;
/**
 * @member {String} bol_number
 */

_BaseShipment["default"].prototype['bol_number'] = undefined;
/**
 * @member {String} cancellation_reason
 */

_BaseShipment["default"].prototype['cancellation_reason'] = undefined;
/**
 * Customer reference number that came back from the capacity provider
 * @member {String} capacity_provider_customer_reference_number
 */

_BaseShipment["default"].prototype['capacity_provider_customer_reference_number'] = undefined;
/**
 * @member {Date} created_at
 */

_BaseShipment["default"].prototype['created_at'] = undefined;
/**
 * @member {module:model/BaseShipment.CreatedBySourceEnum} created_by_source
 */

_BaseShipment["default"].prototype['created_by_source'] = undefined;
/**
 * @member {module:model/SlimUser} created_by_user
 */

_BaseShipment["default"].prototype['created_by_user'] = undefined;
/**
 * @member {module:model/CurrentShipmentAddress} current_address
 */

_BaseShipment["default"].prototype['current_address'] = undefined;
/**
 * @member {module:model/ShipmentCustomData} custom_data
 */

_BaseShipment["default"].prototype['custom_data'] = undefined;
/**
 * @member {module:model/SlimCompany} customer
 */

_BaseShipment["default"].prototype['customer'] = undefined;
/**
 * @member {String} customer_reference_number
 */

_BaseShipment["default"].prototype['customer_reference_number'] = undefined;
/**
 * @member {Boolean} delayed
 */

_BaseShipment["default"].prototype['delayed'] = undefined;
/**
 * @member {String} description
 */

_BaseShipment["default"].prototype['description'] = undefined;
/**
 * @member {Number} documents_count
 */

_BaseShipment["default"].prototype['documents_count'] = undefined;
/**
 * @member {String} drayage_booking_number
 */

_BaseShipment["default"].prototype['drayage_booking_number'] = undefined;
/**
 * @member {String} drayage_chassis_number
 */

_BaseShipment["default"].prototype['drayage_chassis_number'] = undefined;
/**
 * @member {String} drayage_container_number
 */

_BaseShipment["default"].prototype['drayage_container_number'] = undefined;
/**
 * @member {String} drayage_container_return_date
 */

_BaseShipment["default"].prototype['drayage_container_return_date'] = undefined;
/**
 * @member {String} drayage_estimated_arrival_date
 */

_BaseShipment["default"].prototype['drayage_estimated_arrival_date'] = undefined;
/**
 * @member {String} drayage_last_free_date
 */

_BaseShipment["default"].prototype['drayage_last_free_date'] = undefined;
/**
 * @member {String} drayage_release_date
 */

_BaseShipment["default"].prototype['drayage_release_date'] = undefined;
/**
 * @member {String} drayage_seal_number
 */

_BaseShipment["default"].prototype['drayage_seal_number'] = undefined;
/**
 * @member {module:model/EquipmentConfig} equipment_config
 */

_BaseShipment["default"].prototype['equipment_config'] = undefined;
/**
 * @member {module:model/EquipmentType} equipment_type
 */

_BaseShipment["default"].prototype['equipment_type'] = undefined;
/**
 * @member {Number} est_trip_miles
 */

_BaseShipment["default"].prototype['est_trip_miles'] = undefined;
/**
 * @member {String} external_tracking_link
 */

_BaseShipment["default"].prototype['external_tracking_link'] = undefined;
/**
 * @member {Number} final_trip_miles
 */

_BaseShipment["default"].prototype['final_trip_miles'] = undefined;
/**
 * @member {String} group_id
 */

_BaseShipment["default"].prototype['group_id'] = undefined;
/**
 * @member {String} id
 */

_BaseShipment["default"].prototype['id'] = undefined;
/**
 * @member {Boolean} is_watchable
 */

_BaseShipment["default"].prototype['is_watchable'] = undefined;
/**
 * @member {Boolean} is_watched
 */

_BaseShipment["default"].prototype['is_watched'] = undefined;
/**
 * @member {Date} last_cloned_at
 */

_BaseShipment["default"].prototype['last_cloned_at'] = undefined;
/**
 * @member {Array.<module:model/ShipmentLineItem>} line_items
 */

_BaseShipment["default"].prototype['line_items'] = undefined;
/**
 * @member {String} marked_as_paid_by_user
 */

_BaseShipment["default"].prototype['marked_as_paid_by_user'] = undefined;
/**
 * @member {Number} markup
 */

_BaseShipment["default"].prototype['markup'] = undefined;
/**
 * @member {Number} messages_count
 */

_BaseShipment["default"].prototype['messages_count'] = undefined;
/**
 * @member {module:model/ShipmentMetadata} metadata
 */

_BaseShipment["default"].prototype['metadata'] = undefined;
/**
 * @member {module:model/ShipmentMode} mode
 */

_BaseShipment["default"].prototype['mode'] = undefined;
/**
 * @member {String} name
 */

_BaseShipment["default"].prototype['name'] = undefined;
/**
 * @member {String} next_planned_stop_id
 */

_BaseShipment["default"].prototype['next_planned_stop_id'] = undefined;
/**
 * @member {Number} notes_count
 */

_BaseShipment["default"].prototype['notes_count'] = undefined;
/**
 * @member {String} notes_for_carrier
 */

_BaseShipment["default"].prototype['notes_for_carrier'] = undefined;
/**
 * @member {module:model/BaseShipment.ParcelPickupStatusEnum} parcel_pickup_status
 */

_BaseShipment["default"].prototype['parcel_pickup_status'] = undefined;
/**
 * @member {String} pickup_number
 */

_BaseShipment["default"].prototype['pickup_number'] = undefined;
/**
 * @member {String} preferred_currency
 */

_BaseShipment["default"].prototype['preferred_currency'] = undefined;
/**
 * @member {String} pro_number
 */

_BaseShipment["default"].prototype['pro_number'] = undefined;
/**
 * @member {String} purchase_order_number
 */

_BaseShipment["default"].prototype['purchase_order_number'] = undefined;
/**
 * @member {String} reference_id
 */

_BaseShipment["default"].prototype['reference_id'] = undefined;
/**
 * @member {module:model/CarrierAssignment} relationship_to_customer
 */

_BaseShipment["default"].prototype['relationship_to_customer'] = undefined;
/**
 * @member {module:model/CarrierStatusCarrierAssignment} relationship_to_vendor
 */

_BaseShipment["default"].prototype['relationship_to_vendor'] = undefined;
/**
 * Representatives for the Shipment from within the requesting user's own company 
 * @member {Array.<module:model/ShipmentRep>} reps
 */

_BaseShipment["default"].prototype['reps'] = undefined;
/**
 * All RFQs this Shipment has run, slimmed down to exclude their quotes 
 * @member {Array.<module:model/SlimRFQ>} rfqs
 */

_BaseShipment["default"].prototype['rfqs'] = undefined;
/**
 * @member {module:model/ServiceLevel} service_level
 */

_BaseShipment["default"].prototype['service_level'] = undefined;
/**
 * @member {String} shipment_pickup
 */

_BaseShipment["default"].prototype['shipment_pickup'] = undefined;
/**
 * Not implemented
 * @member {Date} significantly_modified_at
 */

_BaseShipment["default"].prototype['significantly_modified_at'] = undefined;
/**
 * @member {module:model/BaseShipment.StateEnum} state
 */

_BaseShipment["default"].prototype['state'] = undefined;
/**
 * @member {Array.<module:model/Stop>} stops
 */

_BaseShipment["default"].prototype['stops'] = undefined;
/**
 * @member {Number} temperature_lower_limit
 */

_BaseShipment["default"].prototype['temperature_lower_limit'] = undefined;
/**
 * @member {Number} temperature_upper_limit
 */

_BaseShipment["default"].prototype['temperature_upper_limit'] = undefined;
/**
 * @member {Array.<module:model/ShipmentTimelineEvent>} timeline_events
 */

_BaseShipment["default"].prototype['timeline_events'] = undefined;
/**
 * @member {Date} timeline_last_updated_at
 */

_BaseShipment["default"].prototype['timeline_last_updated_at'] = undefined;
/**
 * @member {Number} total_declared_value
 */

_BaseShipment["default"].prototype['total_declared_value'] = undefined;
/**
 * @member {module:model/BaseShipment.TotalDeclaredValueCurrencyEnum} total_declared_value_currency
 */

_BaseShipment["default"].prototype['total_declared_value_currency'] = undefined;
/**
 * @member {Number} total_linear_feet
 */

_BaseShipment["default"].prototype['total_linear_feet'] = undefined;
/**
 * @member {Number} total_miles
 */

_BaseShipment["default"].prototype['total_miles'] = undefined;
/**
 * @member {module:model/TotalWeightOverride} total_weight_override
 */

_BaseShipment["default"].prototype['total_weight_override'] = undefined;
/**
 * @member {String} tracking_number
 */

_BaseShipment["default"].prototype['tracking_number'] = undefined;
/**
 * @member {String} trailer_name
 */

_BaseShipment["default"].prototype['trailer_name'] = undefined;
/**
 * @member {Date} updated_at
 */

_BaseShipment["default"].prototype['updated_at'] = undefined;
/**
 * @member {String} v3_shipment_id
 */

_BaseShipment["default"].prototype['v3_shipment_id'] = undefined;
/**
 * @member {module:model/BaseShipment.VersionEnum} version
 */

_BaseShipment["default"].prototype['version'] = undefined; // Implement SlimShipmentAllOf interface:

/**
 * @member {module:model/SlimCompany} current_carrier
 */

_SlimShipmentAllOf["default"].prototype['current_carrier'] = undefined;
/**
 * @member {module:model/ShipmentCustomData} custom_data
 */

_SlimShipmentAllOf["default"].prototype['custom_data'] = undefined;
/**
 * @member {module:model/SlimCarrierAssignment} relationship_to_customer
 */

_SlimShipmentAllOf["default"].prototype['relationship_to_customer'] = undefined;
/**
 * @member {module:model/SlimCarrierStatusCarrierAssignment} relationship_to_vendor
 */

_SlimShipmentAllOf["default"].prototype['relationship_to_vendor'] = undefined;
/**
 * Allowed values for the <code>created_by_source</code> property.
 * @enum {String}
 * @readonly
 */

SlimShipment['CreatedBySourceEnum'] = {
  /**
   * value: "MAGENTO"
   * @const
   */
  "MAGENTO": "MAGENTO",

  /**
   * value: "SHIPWELL_WEB"
   * @const
   */
  "SHIPWELL_WEB": "SHIPWELL_WEB",

  /**
   * value: "SHOPIFY"
   * @const
   */
  "SHOPIFY": "SHOPIFY",

  /**
   * value: "IMPORT"
   * @const
   */
  "IMPORT": "IMPORT",

  /**
   * value: "TENDER"
   * @const
   */
  "TENDER": "TENDER",

  /**
   * value: "SHIPWELL_WEB_UNAUTH"
   * @const
   */
  "SHIPWELL_WEB_UNAUTH": "SHIPWELL_WEB_UNAUTH",

  /**
   * value: "OTHER"
   * @const
   */
  "OTHER": "OTHER"
};
/**
 * Allowed values for the <code>parcel_pickup_status</code> property.
 * @enum {String}
 * @readonly
 */

SlimShipment['ParcelPickupStatusEnum'] = {
  /**
   * value: "CANCELLED"
   * @const
   */
  "CANCELLED": "CANCELLED",

  /**
   * value: "DELAYED"
   * @const
   */
  "DELAYED": "DELAYED",

  /**
   * value: "DELIVERED"
   * @const
   */
  "DELIVERED": "DELIVERED",

  /**
   * value: "IN_TRANSIT"
   * @const
   */
  "IN_TRANSIT": "IN_TRANSIT",

  /**
   * value: "NOT_SCHEDULED"
   * @const
   */
  "NOT_SCHEDULED": "NOT_SCHEDULED",

  /**
   * value: "SCHEDULED"
   * @const
   */
  "SCHEDULED": "SCHEDULED"
};
/**
 * Allowed values for the <code>state</code> property.
 * @enum {String}
 * @readonly
 */

SlimShipment['StateEnum'] = {
  /**
   * value: "appointment_pending"
   * @const
   */
  "appointment_pending": "appointment_pending",

  /**
   * value: "at_pickup"
   * @const
   */
  "at_pickup": "at_pickup",

  /**
   * value: "at_delivery"
   * @const
   */
  "at_delivery": "at_delivery",

  /**
   * value: "auction_running"
   * @const
   */
  "auction_running": "auction_running",

  /**
   * value: "cancelled"
   * @const
   */
  "cancelled": "cancelled",

  /**
   * value: "carrier_confirmed"
   * @const
   */
  "carrier_confirmed": "carrier_confirmed",

  /**
   * value: "delayed"
   * @const
   */
  "delayed": "delayed",

  /**
   * value: "delivered"
   * @const
   */
  "delivered": "delivered",

  /**
   * value: "dispatched"
   * @const
   */
  "dispatched": "dispatched",

  /**
   * value: "draft"
   * @const
   */
  "draft": "draft",

  /**
   * value: "in_transit"
   * @const
   */
  "in_transit": "in_transit",

  /**
   * value: "out_for_delivery"
   * @const
   */
  "out_for_delivery": "out_for_delivery",

  /**
   * value: "quote_accepted"
   * @const
   */
  "quote_accepted": "quote_accepted",

  /**
   * value: "quoting"
   * @const
   */
  "quoting": "quoting",

  /**
   * value: "reconciled"
   * @const
   */
  "reconciled": "reconciled",

  /**
   * value: "scheduled"
   * @const
   */
  "scheduled": "scheduled",

  /**
   * value: "tendered"
   * @const
   */
  "tendered": "tendered"
};
/**
 * Allowed values for the <code>total_declared_value_currency</code> property.
 * @enum {String}
 * @readonly
 */

SlimShipment['TotalDeclaredValueCurrencyEnum'] = {
  /**
   * value: "CAD"
   * @const
   */
  "CAD": "CAD",

  /**
   * value: "USD"
   * @const
   */
  "USD": "USD"
};
/**
 * Allowed values for the <code>version</code> property.
 * @enum {Number}
 * @readonly
 */

SlimShipment['VersionEnum'] = {
  /**
   * value: 2
   * @const
   */
  "2": 2,

  /**
   * value: 3
   * @const
   */
  "3": 3
};
var _default = SlimShipment;
exports["default"] = _default;